import { render, staticRenderFns } from "./jilu-render.vue?vue&type=template&id=c39f6008&"
import script from "./jilu-render.vue?vue&type=script&lang=ts&"
export * from "./jilu-render.vue?vue&type=script&lang=ts&"
import style0 from "./jilu-render.vue?vue&type=style&index=0&id=c39f6008&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports